import { render, staticRenderFns } from "./organizationAdd.vue?vue&type=template&id=98fcd548&scoped=true&"
import script from "./organizationAdd.vue?vue&type=script&lang=js&"
export * from "./organizationAdd.vue?vue&type=script&lang=js&"
import style0 from "./organizationAdd.vue?vue&type=style&index=0&id=98fcd548&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fcd548",
  null
  
)

export default component.exports